import { useEffect, useState } from "react";
import type { JSX } from "react";
import { Navigate, useParams } from "react-router";
import { useDataAdapter } from "@shared-core/data/DataAdapterContext";
import { paths } from "@shared-core/routing/routes";

const TICKET = "workflow.ticket";

/**
 * Compatibility redirect for `/variance-authorisations/:requestId`.
 *
 * The variance authorisation page is gone (purchase invoice matching PIM-6): the buyer answers on their ticket with
 * Answer query…. Tickets raised before then link here by the request's id, which is their ticket's subject id, so
 * the old link opens that ticket's record in One; the ticket list when no ticket has it.
 */
export function LegacyVarianceAuthorisationRedirect(): JSX.Element | null {
  const { requestId } = useParams<{ requestId: string }>();
  const dataAdapter = useDataAdapter();
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    let isCurrent = true;
    const toList = paths.objectList({ objectId: TICKET });
    if (!requestId) {
      setTarget(toList);
      return;
    }
    dataAdapter
      .getTicketViews({
        subjectType: ["variance_authorisation"],
        subjectId: requestId,
        page: 1,
        pageSize: 1,
      })
      .then((found) => {
        const ticket = found.items[0];
        if (isCurrent)
          setTarget(
            ticket
              ? paths.objectRecord({ objectId: TICKET, recordKey: ticket.id })
              : toList,
          );
      })
      .catch(() => {
        if (isCurrent) setTarget(toList);
      });
    return () => {
      isCurrent = false;
    };
  }, [dataAdapter, requestId]);

  return target ? <Navigate to={target} replace /> : null;
}
